import React, { useMemo, useCallback } from 'react'
import * as Presenter from './HostSignUpFormPresenter'

const HostSignUpForm = ({
  account,
  onSubmit,
  actions,
  canSubmit,
}) => {
  const onChange = useCallback(
    e => {
      e.preventDefault()
      const [name] = [e.target.name]
      const payload = {}
      if (name === 'acceptTermOfHost') {
        payload[name] = !account.acceptTermOfHost
      }
      actions.setAccount(payload)
    },
    [account, actions],
  )

  // submitボタンのdisabled判定のために、「ホスト規約に同意する」にチェックが入っているかをチェックする
  const enteredAllInformation = account.acceptTermOfHost

  const submitButtonsComponent = useMemo(() => {
    return (
      <Presenter.SubmitButtons
        onSubmit={onSubmit}
        enteredAllInformation={enteredAllInformation}
        canSubmit={canSubmit}
      />
    )
  }, [onSubmit, enteredAllInformation])
  const termsComponent = useMemo(() => {
    return <Presenter.Terms />
  }, [])
  const acceptTermComponent = useMemo(() => {
    return <Presenter.AcceptTerm account={account} onChange={onChange} />
  }, [account, onChange])
  const otherActionsComponent = useMemo(() => {
    return <Presenter.OtherActions />
  }, [])

  return (
    <Presenter.HostSignUpForm
      termsComponent={termsComponent}
      acceptTermComponent={acceptTermComponent}
      submitButtonsComponent={submitButtonsComponent}
      otherActionsComponent={otherActionsComponent}
      enteredAllInformation={enteredAllInformation}
    />
  )
}

export default HostSignUpForm
